export default __webpack_public_path__ + "static/media/7.03a3df2b.png";